import { c as _c } from "react/compiler-runtime";
export interface GoogleMapEmbedProps {
  /** Address or place query for the map (unencoded). */
  query: string;
  /** Google Maps API key. */
  apiKey?: string;
  /** Aspect ratio CSS value. Defaults to '4/3'. */
  aspectRatio?: string;
  /** Optional className for the iframe. */
  className?: string;
}

/**
 * Google Maps embed atom.
 * Renders a responsive Google Maps iframe for a given address query.
 */
export const GoogleMapEmbed: React.FC<GoogleMapEmbedProps> = t0 => {
  const $ = _c(6);
  const {
    query,
    apiKey,
    aspectRatio: t1,
    className
  } = t0;
  const aspectRatio = t1 === undefined ? "4/3" : t1;
  if (!apiKey) {
    return null;
  }
  let t2;
  if ($[0] !== aspectRatio) {
    t2 = {
      aspectRatio,
      border: "none"
    };
    $[0] = aspectRatio;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${encodeURIComponent(query)}`;
  let t4;
  if ($[2] !== className || $[3] !== t2 || $[4] !== t3) {
    t4 = <iframe title="map" width="100%" style={t2} src={t3} className={className} loading="lazy" referrerPolicy="no-referrer-when-downgrade" />;
    $[2] = className;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};